import React, { useContext, useEffect, useState } from "react";
import {
    Container,
    SectionTitle,
    Actions,
    PrivacyBadge,
    Toggle,
} from "./DataPrivacySettings.styles";
import { ApplicationContext } from "../../../../../../components/ApplicationProvider";

export type PrivacyMode = "Default" | "Comprehensive";

interface DataPrivacySettingsProps {
    initialValue?: PrivacyMode;
    onToggle?: (value: PrivacyMode) => void;
    readOnly?: boolean;
}

const DataPrivacySettings: React.FC<DataPrivacySettingsProps> = ({
    initialValue = "Default",
    onToggle,
    readOnly = false,
}) => {
    const { t } = useContext(ApplicationContext);
    const [privacyMode, setPrivacyMode] = useState<PrivacyMode>(initialValue);
    const isComprehensive = privacyMode === "Comprehensive";

    useEffect(() => {
        setPrivacyMode(initialValue);
    }, [initialValue]);

    const handleToggleChange = (): void => {
        if (readOnly) {
            return;
        }

        const nextPrivacyMode: PrivacyMode = isComprehensive ? "Default" : "Comprehensive";

        setPrivacyMode(nextPrivacyMode);
        onToggle?.(nextPrivacyMode);
    };

    return (
        <Container data-testid="data-privacy-settings">
            <SectionTitle data-testid="data-privacy-settings-title">
                {t("devices.gateways.gateway_card.data_privacy")}
            </SectionTitle>
            <Actions data-testid="data-privacy-settings-actions">
                <PrivacyBadge data-testid="data-privacy-settings-badge">{privacyMode}</PrivacyBadge>
                <Toggle
                    toggle
                    checked={isComprehensive}
                    disabled={readOnly}
                    onChange={handleToggleChange}
                    aria-label={t("devices.gateways.gateway_card.data_privacy")}
                    data-testid="qa_gateway_data_privacy_toggle"
                />
            </Actions>
        </Container>
    );
};

export default DataPrivacySettings;
